import React from 'react';
import '../../styles/onboardingFlow/slides/slide1.scss';
import hubspotIcon from '../../assets/onboarding/slides/slide1/hubspot.svg';
import messageIcon from '../../assets/onboarding/slides/slide1/message.svg';
import searchInput from '../../assets/onboarding/slides/slide1/search-input.svg';
import chat1 from '../../assets/onboarding/slides/slide1/chat1.svg';
import chat2 from '../../assets/onboarding/slides/slide1/chat2.svg';
import chat3 from '../../assets/onboarding/slides/slide1/chat3.png';
import googleLogo from '../../assets/onboarding/slides/slide1/google.svg';

const Slide1 = () => {
  return (
    <div className='slide1'>
      <div className='slide1__content'>
        {/* HubSpot Icon at top */}
        <div className='slide1__hubspot'>
          <img src={hubspotIcon} alt='HubSpot' />
        </div>

        {/* Chat Bubbles */}
        <div className='slide1__chats'>
          <div className='slide1__chat slide1__chat--1'>
            <img src={chat1} alt='Chat 1' />
          </div>
          <div className='slide1__chat slide1__chat--2'>
            <img src={chat2} alt='Chat 2' />
          </div>
          <div className='slide1__chat slide1__chat--3'>
            <img src={chat3} alt='Chat 3' />
          </div>
        </div>

        {/* Search Input - Positioned at top */}
        <div className='slide1__search-container'>
          <div className='slide1__search'>
            <div className='slide1__search-input'>
              <img src={searchInput} alt='Ask Tara' />
            </div>
          </div>

          {/* Google Logo */}
          <div className='slide1__google'>
            <img src={googleLogo} alt='Google' />
          </div>
        </div>

        {/* Main Content */}
        <div className='slide1__main'>
          {/* Title with Icon at the end */}
          <div className='slide1__title'>
            <h1>
              Conversational AI{' '}
              <img
                src={messageIcon}
                alt='Message'
                className='slide1__title-icon'
              />
            </h1>
          </div>

          {/* Subtitle */}
          <h2 className='slide1__subtitle'>Ask anything, Anytime</h2>

          {/* Description */}
          <p className='slide1__description'>
            No more digging through dashboards. Just ask, and get instant
            answers powered by TARA's AI - insights made simple, anytime you
            need them.
          </p>

          {/* Progress Bars */}
          <div className='slide1__progress'>
            <div className='slide1__progress-dot slide1__progress-dot--active'></div>
            <div className='slide1__progress-dot'></div>
            <div className='slide1__progress-dot'></div>
            <div className='slide1__progress-dot'></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slide1;
